import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

export type OrganizationSummaryCardProps = {
	title: string;
	value: number | string;
	isLoading: boolean;
};

const styles = cssMap({
	container: {
		borderRadius: token('radius.large'),
		borderColor: token('color.border'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		padding: token('space.200'),
		minHeight: '80px',
	},
});

export const OrganizationSummaryCard = ({
	title,
	value,
	isLoading,
}: OrganizationSummaryCardProps) => {
	if (isLoading) {
		return (
			<Stack xcss={styles.container} grow="fill" alignBlock="center" space="space.075">
				<Skeleton height="12px" width="100%" />
				<Skeleton height="20px" width="100%" />
			</Stack>
		);
	}

	return (
		<Stack xcss={styles.container} grow="fill" alignBlock="center" space="space.075">
			<Heading size="xxsmall" as="h3">
				{title}
			</Heading>
			<Heading size="medium">{value}</Heading>
		</Stack>
	);
};
